import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IBillingInfoFormSlice {
  billingInfoFormIsDisplayingCard: boolean;
  billingInfoFormCanDisplayCard: boolean;
  billingInfoFormIsDirty: boolean;
  billingInfoFormIsLoading: boolean;
}

export const createBillingInfoFormSliceDefaultValues = (): IBillingInfoFormSlice => ({
  billingInfoFormIsDisplayingCard: true,
  billingInfoFormCanDisplayCard: true,
  billingInfoFormIsDirty: false,
  billingInfoFormIsLoading: false,
});

export const createBillingInfoFormSlice: StateCreator<IBillingInfoFormSlice> = () =>
  createBillingInfoFormSliceDefaultValues();

export type BillingInfoFormPageStore = UseBoundStore<StoreApi<IBillingInfoFormSlice>>;

export const createBillingInfoFormHooks = (pageStore: BillingInfoFormPageStore) => {
  return {
    useIsDisplayingCard: () => pageStore((state) => state.billingInfoFormIsDisplayingCard),
    useCanDisplayCard: () => pageStore((state) => state.billingInfoFormCanDisplayCard),
    useIsLoading: () => pageStore((state) => state.billingInfoFormIsLoading),
  };
};

export type BillingInfoFormHooks = ReturnType<typeof createBillingInfoFormHooks>;
